import React, { useEffect, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {cleanUpObject, combineClassNames, getMediaPath} from '../../app/functions';
import * as routes from '../../constants/routes';
import { getBenefitById } from '../../redux/actions';
import './index.scss';
import QRCode from "react-qr-code";

const Barcode = () => {
    const { benefitId, barcodeNumber } = useParams();

    const dispatch = useDispatch();

    const translations = useSelector((store) => store.config.Translations);
    const benefitTypes = useSelector((store) => cleanUpObject(store.config.IconTypes));
    const benefitData = useSelector((store) => store.data.BenefitPage);

    const [isLoading, setIsLoading] = useState(true);

    const benefitType = benefitTypes?.[benefitData?.['main']?.['benefit_type']];

    const ShimmerWrapper = ({ className }) => (
        <div className={combineClassNames(className, `${className}_skeleton`)}>
            <div className="shimmer-wrapper">
                <div className="shimmer"/>
            </div>
        </div>
    );

    useEffect(() => {
        dispatch(getBenefitById({
            benefitId,
            isCommerce: 0,
        }));

        setIsLoading(true);
    }, [benefitId]);

    useEffect(() => {
        if (benefitData !== false) {
            setIsLoading(false);
        }
    }, [benefitData]);

    return (
        <div className="barcode-page">
            <p className="barcode-instructions">
                {translations['barcode_instructions']}
            </p>

            <div className="barcode-number-container">
                {/* <ReactBarcode value={barcodeNumber} options={{ width: 1, format: 'ITF14' }}/> */}
                <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={barcodeNumber}
                    viewBox={`0 0 256 256`}
                />
            </div>

            {benefitData !== 'error' && (
                <div className="barcode-benefit-container">
                    {isLoading ? (
                        <>
                            <ShimmerWrapper className="benefit-type"/>
                            <ShimmerWrapper className="benefit-title"/>
                            <ShimmerWrapper className="benefit-link"/>
                        </>
                    ) : (
                        <>
                            {(benefitType?.['title']) && (
                                <p className="benefit-type">
                                    {benefitType?.['imagePath'] && (
                                        <img
                                            src={getMediaPath(benefitType?.['imagePath'])}
                                            alt={benefitType?.['title']}
                                            className="benefit-type-icon"
                                        />
                                    )}

                                    {benefitType?.['title']}
                                </p>
                            )}

                            {benefitData?.['main']?.['title'] && (
                                <p className="benefit-title">
                                    {benefitData?.['main']?.['title']}
                                </p>
                            )}

                            {benefitData?.['main']?.['id'] && (
                                <NavLink to={`${routes.benefit}/${benefitData?.['main']?.['id']}`} className="benefit-link">
                                    {translations['barcode_benefit_link']}
                                </NavLink>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default Barcode;
